<template>
    <footer>
        <ul>
            <li id="liReglement" v-show="$parent.IsLogged()"><a href="javascript:void(0)" v-on:click="$parent.GotoReglement()">Règlement</a></li>
            <li><router-link to="/MentionsLegales">Mentions légales</router-link></li>
            <li><router-link to="/Credits">Crédits</router-link></li>
            <!--<li><router-link to="/ListeQuestions">liste question (testeur)</router-link></li>
            <li><router-link to="/QuestionType1">Question type 1</router-link></li>
            <li><router-link to="/QuestionType2">Question type 2</router-link></li>
            <li><router-link to="/QuestionType3">Question type 3</router-link></li>
            <li><router-link to="/Reponse">Réponse</router-link></li>
            <li><router-link to="/DejaJoue">Déjà joué</router-link></li>
            <li><a href="javascript:void(0);" @click="toggleBodyClass('addClass', 'showSpinner')">Show spinner</a></li>
            <li><a href="javascript:void(0);" @click="toggleBodyClass('addClass', 'showBgImage')">Show BG Image</a></li>-->
        </ul>

    </footer>
</template>
<script>
    export default {
        methods: {
            toggleBodyClass(addRemoveClass, className) {
                const el = document.body;

                if (addRemoveClass === 'addClass') {
                    el.classList.add(className);
                } else {
                    el.classList.remove(className);
                }
            },
            mounted: function () {
              

            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
